import React, { createContext, useReducer } from "react";
import { sessionStorageKey } from "../Config/Constants";
import { logger } from "../Middleware/Logger";
import BillingState from "../Models/Billing/BillingState";
import defaultState from "../State/Billing/defaultState";
import BillingReducer from "../State/Billing/Reducer";

const BillingDataContext = createContext<BillingState>({
  state: defaultState,
  dispatch: () => {},
});

type Props = {
  children: React.ReactNode;
};

export const BillingDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(BillingReducer, defaultState, () => {
    try {
      const saveState = sessionStorage.getItem(sessionStorageKey.BILLING_STATE);
      if (saveState) {
        return JSON.parse(saveState);
      }
      return defaultState;
    } catch (error) {
      logger.error("🚀 ~ file: BillingDataContext.context.tsx ~ line 18 ~ useReducer ~ error", error);
    }
  });
  return <BillingDataContext.Provider value={{ state, dispatch }}>{children}</BillingDataContext.Provider>;
};

export default BillingDataContext;
